<!-- @format -->

<a
	*ngIf="data?.link && !data?.youtubeId"
	[href]="data?.link"
	[attr.data-em]="data?.DataEMTag"
	class="hmf-mx-s hmf-mx-m-0 hmf-mb-xl">
	<ng-template [ngTemplateOutlet]="image"></ng-template>
</a>
<div *ngIf="!data?.link && !data?.youtubeId">
	<ng-template [ngTemplateOutlet]="image"></ng-template>
</div>
<ng-template #image>
	<div class="hmf-px-s hmf-pb-s">
		<shared-media-component-media
			[visualAssets]="data?.visualAssets"
			[altText]="data?.altText"
			[gif]="data?.gif"
			[gifMobile]="data?.gifMobile"
			[image]="data?.image"
			[mobileImg]="data?.mobileImg"
			[itemTitle]="''">
		</shared-media-component-media>
	</div>
</ng-template>
<ng-container *ngIf="data?.youtubeId">
	<shared-media-component-media
		[visualAssets]="data?.visualAssets"
		[altText]="data?.altText"
		[image]="data?.image"
		[mobileImg]="data?.mobileImg"
		[itemTitle]="data?.title ? data?.title : data?.headline"
		[youtubeId]="data?.youtubeId"
		[animation]="data?.animation">
	</shared-media-component-media>
</ng-container>
